"use client";

import Carousel from "@/components/common/Carousel";

import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Row } from "antd";
import Paragraph from "../../common/Typography/Paragraph";
import Text from "../../common/Typography/Text";
import Title from "../../common/Typography/Title";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import { useTranslation } from "react-i18next";
import Link from "@/components/common/LinkNext";
import { useTETranslation } from "@/hooks/app/useTETranslation";
import NewsItem from "./NewsItem";

const NewsSection = ({ listNews: data }: any) => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation()
  const { getValidDayjs } = useTETranslation()

  // if (loading) {
  //   return (
  //     <Row
  //       className="home__news"
  //       justify="center"
  //       style={{
  //         paddingBlock: "4rem",
  //       }}
  //     >
  //       <Col span={24} className="home__deals--box">
  //         <Row justify="center" style={{ padding: "2rem 0" }}>
  //           <Spin size="large" />
  //         </Row>
  //       </Col>
  //     </Row>
  //   );
  // }

  if (!data?.length) {
    return null;
  }

  if (!isDesktop) {
    return (
      <Col span={24}>
        <Row justify="space-between" align="middle">
          <Col>
            <Title
              level={2}
              style={{
                margin: 0,
              }}
            >
              {t("home.section_news_title")}
            </Title>
          </Col>
        </Row>

        <Row>
          <Text type="secondary" style={{ marginBottom: "2rem" }}>
            {t("home.section_news_desc")}
          </Text>
        </Row>
        <Carousel
          options={{
            pageDots: false,
            cellAlign: "left",
            draggable: true,
            prevNextButtons: true,
            groupCells: 1,
            freeScroll: false,
          }}
        >
          {data.map((blog: any) => (
            <div key={blog.id} style={{ width: "100%", padding: "0 7.5px" }}>
              <Link href={`/explore/${blog.slug}`}>
                <NewsItem blog={blog} />
              </Link>
            </div>
          ))}
        </Carousel>
      </Col>
    );
  }

  return (
    <Col span={24}>
      <Row justify="space-between" align="middle">
        <Col>
          <Title
            level={2}
            style={{
              margin: 0,
            }}
          >
            {t("home.section_news_title")}
          </Title>
        </Col>
      </Row>

      <Row>
        <Text type="secondary" style={{ marginBottom: "2rem" }}>
          {t("home.section_news_desc")}
        </Text>
      </Row>

      {data.length <= 4 ? (
        <Row gutter={[15, 15]}>
          {data.map((blog: any) => (
            <Col key={blog.id} xs={24} sm={12} md={8} lg={6}>
              <Link href={`/explore/${blog.slug}`}>
                <NewsItem blog={blog} />
                {/* <Card
                  hoverable
                  cover={
                    <div
                      style={{
                        height: "180px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        alt={blog.title}
                        src={blog.thumbnail_url}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </div>
                  }
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "none",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    height: "320px",
                  }}
                  bodyStyle={{
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    height: "140px",
                  }}
                >
                  <div style={{ marginBottom: "0.5rem" }}>
                    <Text type="secondary" style={{ fontSize: "11px" }}>
                      <FontAwesomeIcon
                        icon={faCalendarAlt}
                        style={{ marginRight: "4px" }}
                      />
                      {getValidDayjs(blog.created_at).format("DD/MM/YYYY")}
                    </Text>
                  </div>

                  <Title
                    level={5}
                    style={{
                      margin: 0,
                      marginBottom: "0.5rem",
                      fontSize: "1.3rem",
                      lineHeight: "1.3",
                      color: "#262626",
                      fontWeight: "600",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "3.5rem",
                    }}
                  >
                    {blog.title}
                  </Title>

                  <Paragraph
                    ellipsis={{ rows: 2 }}
                    style={{
                      marginTop: "8px",
                      marginBottom: 0,
                      fontSize: "12px",
                    }}
                  >
                    {blog.summary}
                  </Paragraph>
                </Card> */}
              </Link>
            </Col>
          ))}
        </Row>
      ) : (
        <Carousel
          options={{
            pageDots: false,
            cellAlign: "left",
            draggable: true,
            prevNextButtons: true,
            groupCells: 1,
            freeScroll: false,
          }}
        >
          {data.map((blog: any) => (
            <div key={blog.id} style={{ width: "25%", padding: "0 7.5px" }}>
              <Link href={`/explore/${blog.slug}`}>
                <Card
                  hoverable
                  cover={
                    <div
                      style={{
                        height: "180px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        alt={blog.title}
                        src={blog.thumbnail_url}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                      />
                    </div>
                  }
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "none",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    height: "320px",
                  }}
                  styles={{
                    body: {
                      padding: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      height: "140px",
                    }
                  }}
                >
                  <div style={{ marginBottom: "0.5rem" }}>
                    <Text type="secondary" style={{ fontSize: "11px" }}>
                      <FontAwesomeIcon
                        icon={faCalendarAlt}
                        style={{ marginRight: "4px" }}
                      />
                      {getValidDayjs(blog.created_at).format("DD/MM/YYYY")}
                    </Text>
                  </div>

                  <Title
                    level={5}
                    style={{
                      margin: 0,
                      marginBottom: "0.5rem",
                      fontSize: "1.1rem",
                      lineHeight: "1.3",
                      color: "#262626",
                      fontWeight: "600",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "2.6rem",
                    }}
                  >
                    {blog.title}
                  </Title>

                  <Paragraph
                    style={{
                      margin: 0,
                      color: "#666",
                      fontSize: "12px",
                      lineHeight: "1.4",
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1,
                    }}
                  >
                    {blog.summary}
                  </Paragraph>
                </Card>
              </Link>
            </div>
          ))}
        </Carousel>
      )}

      {/* <Row justify="center" style={{ marginTop: "2rem" }}>
          <Link href="/explore?category=NEWS">
            <Button
              type="primary"
              size="large"
              style={{
                borderRadius: "8px",
                background: "linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)",
                border: "none",
                height: "40px",
                fontWeight: "500",
              }}
            >
              Xem tất cả tin tức
            </Button>
          </Link>
        </Row> */}
    </Col>
  );
};

export default NewsSection;
